import { alertConstants } from "../constants/alert.constants";

export function alert(state = {}, action) {
  switch (action.type) {
    case alertConstants.PROMPT:
      return {
        type: alertConstants.PROMPT,
        message: action.message,
      };
    case alertConstants.SPINNER:
      return {
        type: alertConstants.SPINNER,
        message: action.message,
      };
    case alertConstants.SUCCESS:
      return {
        type: alertConstants.SUCCESS,
        message: action.message,
      };
    case alertConstants.ERROR:
      return {
        type: alertConstants.ERROR,
        message: action.message,
      };
    case alertConstants.CLEAR:
      return {};
    default:
      return state;
  }
}
